/**
 * @file コンポーネント：フル動画ページセッションエラーモーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    buttonType: "caution",
                    href: props.url,
                    text: localized["Label.Ok"],
                },
            ]}
            content={[
                <Paragraph
                    key="paragraph"
                    onColor="white"
                    text={localized["ErrorMessage.SessionExpiredDescription"]}
                />,
            ]}
            hasButtonClose={false}
            isShow={true}
        />
    );
};
